import { render } from "./RootNodeConfig.vue?vue&type=template&id=25da8c06&scoped=true&ts=true"
import script from "./RootNodeConfig.vue?vue&type=script&lang=ts"
export * from "./RootNodeConfig.vue?vue&type=script&lang=ts"

import "./RootNodeConfig.vue?vue&type=style&index=0&id=25da8c06&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25da8c06"]])

export default __exports__